export const REVAMPED_PRICING_COPY_EXP_FLAG = 'pen-4819_v1'
